import { render, staticRenderFns } from "./iDealSelector.vue?vue&type=template&id=16dfb4af&"
import script from "./iDealSelector.vue?vue&type=script&lang=js&"
export * from "./iDealSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports